import React from 'react';
import PropTypes from 'prop-types';
import {VectorBlock} from '../VectorBlock';

export function SectionLeft(props) {
  return (
    <div className={props.className}>
      {/*<VectorBlock className={`${props.className}_vectorblock`} />*/}
      {props.children}
    </div>
  );
}

SectionLeft.propTypes = {
  /**
   * ClassName to set on component
   */
  className: PropTypes.string,
  /**
   * Children to be rendered inside component
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

SectionLeft.defaultProps = {};
